import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from '../company/company-models.model';
import { DocumentCodeCategory } from './document-code-category.model';

@HateoasResource('documentcode')
export class DocumentCode extends CompanyOwned {
  public naam!: string;
  public categorie: DocumentCodeCategory | null = null;
  public inhoud!: string;
  public verborgen!: boolean;
}
